import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationContentSpecificationForHearingInitialize } from '../../../../../features/actions/api';
import { notificationContentForNotificationContentSpecificationWithIdSelector } from '../../../../../features/apiFeatures/notificationContentSlice';
import {
  isFetchingNotificationContentSpecificationsSelector,
  notificationContentSpecificationByHearingIdAndTypeSelector,
} from '../../../../../features/apiFeatures/notificationContentSpecificationSlice';
import { notificationTypeByTypeSelector } from '../../../../../features/apiFeatures/notificationTypeSlice';
import { isAppReadySelector } from '../../../../../features/bootstrapSlice';
import {
  downloadTestNotification,
  initializeNotificationPanelState,
  isNotificationPanelOpenSelector,
  sendTestNotification,
  updateNotificationContentData,
} from '../../../../../features/componentFeatures/notificationPanelSlice';
import {
  globalMessageModes,
  setGlobalMessage,
} from '../../../../../features/globalMessageSlice';
import { getEntityId } from '../../../../../features/helpers/apiHelpers';

export const useUpdateNotificationContentPanel = (
  hearingId,
  notificationTypeValue,
) => {
  const dispatch = useDispatch();
  const isAppReady = useSelector(isAppReadySelector);

  useEffect(() => {
    if (isAppReady && hearingId) {
      dispatch(
        getNotificationContentSpecificationForHearingInitialize({ hearingId }),
      );
    }
  }, [isAppReady, hearingId, dispatch]);

  const isPanelOpen = useSelector(isNotificationPanelOpenSelector);
  const isFetching = useSelector(
    isFetchingNotificationContentSpecificationsSelector,
  );

  const notificationContentSpecification = useSelector(
    notificationContentSpecificationByHearingIdAndTypeSelector(
      hearingId,
      notificationTypeValue,
    ),
  );

  const notificationContentSpecificationId = getEntityId(
    notificationContentSpecification,
  );

  const notificationContent = useSelector(
    notificationContentForNotificationContentSpecificationWithIdSelector(
      notificationContentSpecificationId,
    ),
  );

  const notificationType = useSelector(
    notificationTypeByTypeSelector(notificationTypeValue),
  );

  const onDismiss = (hasChanges) => {
    if (hasChanges) {
      dispatch(
        setGlobalMessage({ mode: globalMessageModes.cancelEditNotification }),
      );
    } else {
      dispatch(initializeNotificationPanelState());
    }
  };

  const onSave = () =>
    dispatch(
      updateNotificationContentData({
        hearingId,
        notificationContentSpecificationId,
      }),
    );

  const onDownloadNotification = (notificationType) =>
    dispatch(
      downloadTestNotification({
        hearingId: hearingId,
        notificationType: notificationType,
      }),
    );

  const onSendNotification = (notificationType) =>
    dispatch(
      sendTestNotification({
        hearingId: hearingId,
        notificationType: notificationType,
      }),
    );

  return {
    isPanelOpen,
    onDismiss,
    onSave,
    onDownloadNotification,
    onSendNotification,
    notificationContent,
    notificationType,
    isFetching,
  };
};
